import React from 'react'
import Grid from '@mui/material/Grid'
import * as Texts from './Text'
import Alert from '@mui/material/Alert';

const Success = props => {
    return <Alert severity='success' >
        {props.children ? props.children :
        <Texts.Text>{props.message}</Texts.Text>}
    </Alert>
}

const Info = props => {
    return <Alert severity='info' >
    {props.children ? props.children :
    <Texts.Text>{props.message}</Texts.Text>}
</Alert>
}

const Warning = props => {
    return <Alert severity='warning' >
    {props.children ? props.children :
    <Texts.Text>{props.message}</Texts.Text>}
</Alert>
}

const Error = props => {
    return <Alert severity='error' >
    {props.children ? props.children :
    <Texts.Text>{props.message}</Texts.Text>}
</Alert>
}



export { Success, Info, Warning, Error }